var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaptop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#394049"
    },
    d: "M473.846,372.729H38.154V129.144c0-14.711,11.925-26.636,26.636-26.636h382.42 c14.711,0,26.636,11.925,26.636,26.636L473.846,372.729L473.846,372.729z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9EDBF5"
    },
    d: "M73.762,372.729v-223.62c0-6.062,4.932-10.993,10.993-10.993h342.49 c6.062,0,10.993,4.932,10.993,10.993v223.62H73.762z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "wave",
    style: {
      fill: "#ED6EA4"
    },
    d: "M342.037,311.009c-4.38,0-8.813-0.322-13.261-0.98c-6.283-0.929-10.623-6.775-9.693-13.059 c0.929-6.283,6.786-10.629,13.059-9.693c18.534,2.74,36.448-2.221,47.912-13.272c9.98-9.622,14.31-23.262,12.518-39.444 c-0.698-6.314,3.853-11.997,10.165-12.696c6.306-0.69,11.997,3.852,12.696,10.165c2.567,23.2-4.327,43.988-19.415,58.534 C382.339,303.75,362.81,311.009,342.037,311.009z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED6EA4"
    },
    d: "M236.527,190.884c-31.109-31.109-81.588-31.043-112.615,0.199 c-30.958,31.173-30.257,81.762,0.809,112.827l94.203,94.203c9.722,9.722,25.485,9.722,35.207,0l94.203-94.203 c31.065-31.065,31.766-81.655,0.809-112.827C318.116,159.841,267.636,159.775,236.527,190.884z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.12,
      enableBackground: "new"
    },
    d: "M349.142,191.083c-12.139-12.223-27.256-19.673-43.025-22.352 c9.145,3.906,17.708,9.602,25.151,17.095c30.958,31.173,30.257,81.762-0.808,112.828l-94.203,94.203 c-4.243,4.243-9.636,6.633-15.175,7.173c9.772,7.752,24.017,7.117,33.049-1.916l94.203-94.203 C379.399,272.845,380.1,222.255,349.142,191.083z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#394049"
    },
    d: "M245.464,269.609c-3.293,0-6.363-0.974-8.937-2.648c-2.574,1.674-5.644,2.648-8.937,2.648 c-9.063,0-16.438-7.374-16.438-16.438c0-4.143,3.358-7.5,7.5-7.5s7.5,3.357,7.5,7.5c0,0.793,0.645,1.438,1.438,1.438 s1.437-0.645,1.437-1.438c0-4.143,3.358-7.5,7.5-7.5s7.5,3.357,7.5,7.5c0,0.793,0.645,1.438,1.437,1.438 c0.792,0,1.437-0.645,1.437-1.438c0-4.143,3.358-7.5,7.5-7.5c4.143,0,7.5,3.357,7.5,7.5 C261.901,262.235,254.528,269.609,245.464,269.609z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M178.346,274.602h-10.322c-4.142,0-7.5-3.357-7.5-7.5s3.358-7.5,7.5-7.5h10.322 c4.142,0,7.5,3.357,7.5,7.5S182.488,274.602,178.346,274.602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M305.031,274.602h-10.322c-4.143,0-7.5-3.357-7.5-7.5s3.357-7.5,7.5-7.5h10.322 c4.142,0,7.5,3.357,7.5,7.5S309.174,274.602,305.031,274.602z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#394049"
    },
    d: "M180.137,254.966c-3.145,0-5.837-1.936-6.952-4.681c-1.114,2.745-3.807,4.681-6.952,4.681 c-4.142,0-7.5-3.357-7.5-7.5c0-7.969,6.483-14.452,14.452-14.452s14.452,6.483,14.452,14.452 C187.637,251.608,184.279,254.966,180.137,254.966z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#394049"
    },
    d: "M306.821,254.966c-3.145,0-5.837-1.936-6.952-4.68c-1.114,2.744-3.807,4.68-6.951,4.68 c-4.143,0-7.5-3.357-7.5-7.5c0-7.969,6.483-14.452,14.452-14.452s14.451,6.483,14.451,14.452 C314.321,251.608,310.964,254.966,306.821,254.966z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEAEA"
    },
    d: "M500.245,372.729H11.755C5.263,372.729,0,377.992,0,384.484v13.253 c0,6.492,5.263,11.755,11.755,11.755h488.491c6.492,0,11.755-5.263,11.755-11.755v-13.253 C512,377.992,506.737,372.729,500.245,372.729z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.12,
      enableBackground: "new"
    },
    d: "M295.451,372.729h-78.902v7.379c0,6.076,4.926,11.002,11.002,11.002 h56.898c6.076,0,11.002-4.926,11.002-11.002V372.729z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 256,
    cy: 120.31,
    r: 7.41
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.12,
      enableBackground: "new"
    },
    d: "M447.21,102.508h-19.473c14.71,0,26.636,11.925,26.636,26.636v222.151 H38.154v21.435h435.693V129.144C473.846,114.433,461.921,102.508,447.21,102.508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.12,
      enableBackground: "new"
    },
    d: "M500.245,372.729h-26.399c6.492,0,11.755,5.263,11.755,11.755v13.254 c0,6.492-5.263,11.755-11.755,11.755h26.399c6.492,0,11.755-5.263,11.755-11.755v-13.254 C512,377.992,506.737,372.729,500.245,372.729z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.bab92e54.svg";
export { ForwardRef as ReactComponent };